

import * as firebase from "firebase/app";
import 'firebase/storage'


  // Your web app's Firebase configuration
  var firebaseConfig = {
    apiKey: "AIzaSyAG1y7q0utKWqADwBu_eQyuA9G6ggtPNy0",
    authDomain: "p-nadi-firebase.firebaseapp.com",
    databaseURL: "https://p-nadi-firebase.firebaseio.com",
    projectId: "p-nadi-firebase",
    storageBucket: "p-nadi-firebase.appspot.com",
    messagingSenderId: "63528684964",
    appId: "1:63528684964:web:840635c021f34d768d0531",
    measurementId: "G-9H58C7V4WW"
  };
  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);
  // firebase.analytics();
// TODO: Replace the following with your app's Firebase project configuration

export default firebase


// let result = await firebase.storage.uploadFile({

//     // firebase.storage.uploadFile({
//     // optional, can be omitted since 6.5.0, and also be passed during init() as 'storageBucket' param so we can cache it (find it in the Firebase console)
//     bucket: myBcuket,
    
//     // the full path of the file in your Firebase storage (folders will be created)
//      remoteFullPath: `p-nadi/images/${folderName}/${imageName}`,
    
//     // option 1: a file-system module File object
//     localFile: fs.File.fromPath(file._path),
    
//     // option 2: a full file path (ignored if 'localFile' is set)
//     // localFullPath: logoPath,
    
//     // get notified of file upload progress
//     onProgress: function(status) {
//       console.log("Uploaded fraction: " + status.fractionCompleted);
//       console.log("Percentage complete: " + status.percentageCompleted);

//       uploadingPercentage('Uploading image: ' + status.percentageCompleted + '%');
//     },
//     metadata
// });

//   export default{


//     async uploadImageToFirebase(file, firebase, folderName, imageName, changeIndicator, uploadingPercentage){
        
//         console.log(`******** Firebase before uploading with file ${file}`);
//         // console.log(`******** Firebase before uploading with file ${JSON.stringify(file)}`);


//         changeIndicator(true);

//         let result = await firebase.storage.uploadFile({

//             // firebase.storage.uploadFile({
//             // optional, can be omitted since 6.5.0, and also be passed during init() as 'storageBucket' param so we can cache it (find it in the Firebase console)
//             bucket: myBcuket,
            
//             // the full path of the file in your Firebase storage (folders will be created)
//              remoteFullPath: `p-nadi/images/${folderName}/${imageName}`,
            
//             // option 1: a file-system module File object
//             localFile: fs.File.fromPath(file._path),
            
//             // option 2: a full file path (ignored if 'localFile' is set)
//             // localFullPath: logoPath,
            
//             // get notified of file upload progress
//             onProgress: function(status) {
//               console.log("Uploaded fraction: " + status.fractionCompleted);
//               console.log("Percentage complete: " + status.percentageCompleted);

//               uploadingPercentage('Uploading image: ' + status.percentageCompleted + '%');
//             },
//             metadata
//           });

//         console.log(`******* Firebase result is ${result.name}`);

//         changeIndicator(false);
//         uploadingPercentage('');

//         return result;
//     },

//     async getImageFromFirebase (firebase, folderName, imageName){



//         let result = await firebase.storage.getDownloadUrl({

//             // firebase.storage.uploadFile({
//             // optional, can be omitted since 6.5.0, and also be passed during init() as 'storageBucket' param so we can cache it (find it in the Firebase console)
//             bucket: myBcuket,
            
//             // the full path of the file in your Firebase storage (folders will be created)
//              remoteFullPath: `p-nadi/images/${folderName}/${imageName}`,
//           });

//           console.log(`******* Firebase result is ${result.name}`);

//           return result;
//     }

// }